import React, {useRef, useState} from 'react';

import {useRouter} from 'next/router';
import {
  findPrimaryStockLocation,
  getGrossPriceString,
} from '../../lib/utils/productUtils';
import Image from 'next/image';
import ContainedButton from '../buttons/containedButton';
import {useTranslation} from 'next-i18next';
import TailwindUiModal from '../layout/TailwindUiModal';

export default function MacroProducts({macroProducts}) {

  const {push, asPath} = useRouter();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const modalRef = useRef(null);

  const {t: translateCommon} = useTranslation('common');
  const {t: translatePages} = useTranslation('pages');

  const productLength = macroProducts.filter(({isPublic}) => isPublic).length;

  const macroProductComponents = macroProducts.filter(({isPublic}) => isPublic).
      map(product => {

        const {
          media,
          shortTitle,
          sellingPointsTitle,
          id: productId,
        } = product.macroProduct;
        const {wireframe} = media;
        const {small} = wireframe.formats;

        let productAvailable = false;

        let minPrice = product.macroProduct.microProducts[0].price.netPrice;
        const taxInPercent = product.macroProduct.microProducts[0].price.tax.taxPercent;
        const currency = product.macroProduct.microProducts[0].price.currency;
        const currencyOnRight = true;
        let isInSale = false;
        let minSalePrice = product.macroProduct.microProducts[0].price.netPrice;

        product.macroProduct.microProducts.map(microProduct => {

          const {netPrice, inSale, salePrice} = microProduct.price;

          if (inSale) {
            isInSale = true;
          }

          if (inSale && minSalePrice > salePrice) {
            minSalePrice = salePrice;
          }

          if (netPrice < minPrice) {
            minPrice = microProduct.price.netPrice;
          }

          const stockInformation = findPrimaryStockLocation(
              microProduct.stocks);
          productAvailable = stockInformation.qty > 0 ||
              stockInformation.allowBackorder;

        });

        const price = getGrossPriceString(minPrice, taxInPercent, currency,
            currencyOnRight);

        const salePrice = getGrossPriceString(minSalePrice, taxInPercent,
            currency,
            currencyOnRight);

        async function onClickMainProduct(e, item) {
          e.preventDefault();
          const slug = item.macroProduct.slug;
          await push(`${asPath}/${slug}`);

        }

        return <div key={`MACRO_PRODUCT_${productId}`}
                    className="w-full flex flex-col gap-5 items-center border-b pb-10 md:border-0 md:pb-0">
          <div className={'w-72 b-72 bg-gray-800'}/>
          {media.useVideoPreview ?
              <video
                  style={{borderRadius: '5px', height: '100%', width: '100%'}}
                  poster={`${media.videoThumbnail.formats.small.url}`}
                  controls="controls">
                <source
                    src={`${media.videoOrImagePreview.url}`}
                    type="video/mp4"/>
                Your browser does not support the video tag.
              </video> :
              <div className={'w-56'}>
                <Image src={small.url}
                       alt={wireframe.alternativeText}
                       height={small.height}
                       width={small.width}
                       layout={'responsive'}
                       quality={100}/>
              </div>

          }
          <div>
            <h3 className={'font-title uppercase text-black text-center h-8'}>{shortTitle}</h3>
            <p className={'text-tiny'}>{sellingPointsTitle}</p>
          </div>
          <div>
            <p className={`font-bold ${productAvailable ?
                'text-emerald-600' :
                'text-red-600'}`}>{productAvailable ?
                translatePages('CATEGORY.AVAILABLE') :
                translatePages('CATEGORY.SOLD_OUT')}</p>
            <p className={'text-tiny'}>
              {translatePages('CATEGORY.INCL_TAX')} | {translatePages(
                'CATEGORY.FREE_SHIPPING_IN_DE')}</p>
          </div>

          {isInSale ?
              <div className={'flex flex-row'}>
                <p
                    className={`mb-0`}>
                  {translatePages('CATEGORY.FROM')} {' '}
                  <del
                      className={'mr-2'}> {price} </del>
                  {salePrice}</p>
                <svg
                    className="w-6 h-6 text-blue-800 ml-2 cursor-pointer"
                    onClick={(e) => handleShowModal(e)}
                    fill="none"
                    stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              :
              <p
                  className={`mb-0`}> {translatePages(
                  'CATEGORY.FROM')} {' '}
                {salePrice}</p>
          }

          <center>
            <ContainedButton className={''}
                             onClick={(e) => onClickMainProduct(e, product)}
                             size={'sm'}>
              {translateCommon('BTN.CONFIGURE')}
            </ContainedButton>
          </center>
        </div>;

      });

  const handleShowModal = async (e) => {
    e.preventDefault();

    setModalIsOpen(true);
  };

  const line1 = translateCommon('POPUP.DISCOUNT_1');
  const line2 = translateCommon('POPUP.DISCOUNT_2');
  const line3 = translateCommon('POPUP.DISCOUNT_3');
  const line4 = translateCommon('POPUP.DISCOUNT_4');

  return <>
    <TailwindUiModal setOpen={setModalIsOpen} open={modalIsOpen}
                     reference={modalRef}
                     onClose={() => setModalIsOpen(false)}>
      <div className="text-sm text-center p-5">
        <Image
            src={`https://amptech-spaces.fra1.digitaloceanspaces.com/strapi/e13867144debbabd926b9249dcaa77cd.png`}
            alt="HAHA YES"
            height="458px" width="544px"
            layout={'responsive'}
            quality={100}/>
        {/*<img*/}
        {/*    src="https://amptech-spaces.fra1.digitaloceanspaces.com/strapi/e13867144debbabd926b9249dcaa77cd.png"*/}
        {/*    alt="HAHA YES" height="458px" width="544px"/>*/}
        <span className="block"> {line1} </span> <br/>
        <span className="block font-bold">{line2} </span> <br/>
        <span className="block"> {line3} </span>
        <br/>
        <span className="block"> {line4}  </span>
      </div>
    </TailwindUiModal>
    <section>
      <center>
        <h2 className={'uppercase font-title tracking-wide text-3xl p-8'}>
          {translatePages('CATEGORY.EXTERIOR')}
        </h2>

        <div
            className="container p-8 mx-auto bg-white mb-8 shadow shadow-lg rounded">
          <div
              className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-${productLength} gap-10`}
              ref={modalRef}>
            {macroProductComponents}
          </div>
        </div>
      </center>
    </section>


  </>;
}
